// src/utils/emojiSearch.js
// Search helper for EmojiPickerModal.
// Only returns emojis that are in the provided `list` — never leaks across categories.

/**
 * Filter `list` by `query` using keyword hints from `emojiDb`.
 * @param {string} query - User's search string
 * @param {string[]} list - The active emoji list (CHORE_EMOJIS, MASCOT_EMOJIS, etc.)
 * @param {Array<{e:string,k:string}>} emojiDb - Keyword lookup table
 * @returns {string[]} Filtered subset of `list`
 */
export function searchEmojiList(query, list, emojiDb) {
  if (!query.trim()) return list;
  const q = query.toLowerCase();

  // Build a Set for O(1) membership checks
  const listSet = new Set(list);

  // Exact Unicode match first (user pasted an emoji)
  if (listSet.has(q)) return [q];

  return list.filter((emoji) => {
    if (emoji === q) return true;
    const dbEntry = emojiDb.find((item) => item.e === emoji);
    return dbEntry?.k?.toLowerCase().includes(q) ?? false;
  });
}